import { apis } from 'ui-common'

export default {
  updateSymptom: ({ qPage1Id, info }: any) => apis.$put(
    `/symptoms/${qPage1Id}`,
    info
  ),
  createSymptom: ({ info }: any) => apis.$put('/symptoms', info)
}
